import { useEffect, useRef } from 'react';

/**
 * 컴포넌트 unmount 시 callback을 1회 실행한다.
 *
 * 매 render마다 ref에 최신 callback을 미러링하므로,
 * cleanup이 호출되는 시점에 항상 최신 closure(=최신 props/state)를 본다.
 * `useEffect([], cleanup)` 패턴의 stale-closure 한계를 회피하는 표준 패턴.
 *
 * @example
 * useUnmount(() => {
 *   logger.track('biz_ai_generation_modal_closed', {
 *     generation_id: generation.generationId,
 *     generated_question_count: generation.items.length,
 *   });
 * });
 */
export function useUnmount(callback: () => void): void {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    return () => {
      callbackRef.current();
    };
  }, []);
}
